<div class="ig-search-wrap" #container>
    <!--<form ngForm="searchFormGroup">-->
    <ig-field #field igDebounce [label]="placeHolder"
              [isInnerLabel]="true"
              [formControl]="searchFormGroup.get('search')"
              [icon]="isLoading?'':searchParam.isShowSearchResult?'clear':'search'"
              [disabled]="disabled"
              (onIconClick)="clearSearchText()"
              [(ngModel)]="searchParam.searchText"
              (debounceKeyup)="search()">
    </ig-field>
    <mat-spinner *ngIf="isLoading"
                 [diameter]="22" [strokeWidth]="3"></mat-spinner>
    <!--<ig-button class="ig-alt-btn" (trigger)="search()"><mat-icon>search</mat-icon></ig-button>-->
    <div class="search-result" *ngIf="searchParam.isShowSearchResult" #result>
        <div *ngIf="searchParam.isNoResult">(no result)</div>
        <ng-container *ngIf="!searchParam.isNoResult">
            <div item class="ellipsis" *ngFor="let result of searchParam.searchResult;let i = index"
                 (click)="onSearchItemClick(result)">
                <div *ngIf="searchParam.isShowResultCount">{{i}}</div>
                {{result.name}}
            </div>
        </ng-container>
    </div>
    <!--</form>-->
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/search/search.component.html